// extracted by mini-css-extract-plugin
export default {"skipContainer":"Rq4j4OO","skipLink":"g62ycH4 TYb4J9A EVhxZk8 leavesden2"};